export default __webpack_public_path__ + "static/media/report_no_color.82365211.png";